import { check } from "@xams-utils/check-types";

const isValidMessage = (message) => {
    const emptyMessage = ["MESSAGE UNDEFINED", "MESSAGE_UNDEFINED"];
    return (
        check.nonEmptyString(message) && emptyMessage.indexOf(message) === -1
    );
};

export { isValidMessage };
